import { connect } from 'react-redux';
import { arrayPush } from 'redux-form';

import { AppDispatch, AppState } from 'bootstrap.store';
import { getConversationFormName } from 'components/conversation/utils/conversationForm';
import { AddUserPayload, userModalActions } from 'components/usersModal';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { composeEmailActions } from '../../../shared/composeEmail/actions/composeEmailActions';
import RecipientPill from '../../components/messages/utils/RecipientPill';

const mapStateToProps = (state: AppState, ownProps: any) => {
  return {
    id: ownProps.id,
    toList: ownProps.toList,
    ccList: ownProps.ccList,
    bccList: ownProps.bccList,
    attachedFiles: ownProps.attachedFiles,
    originalContentUrl: ownProps.originalContentUrl,
    from: ownProps.from,
    csid: state.conversation.metaConversation.conversation.id,
    isAssignedToMe: state.conversation.metaConversation.isAssignedToMe,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    arrayPush: (csid: number, field: string, value: any) =>
      dispatch(arrayPush(getConversationFormName(csid), field, value)),
    composeEmailFindUser: bindActionToPromise(
      dispatch,
      composeEmailActions.composeEmailFindUser,
    ),
    userModalAddUser: (payload: AddUserPayload) =>
      dispatch(userModalActions.user.add(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RecipientPill);
